import {
  INDIVIDUAL_ENTITY_SUCCESS,
  INDIVIDUAL_ENTITY_FAILED,
  RESET_INDIVIDUAL_ENTITY,
  LOADING_INDIVIDUAL_ENTITY,
  NETWORK_ERROR_INDIVIDUAL_ENTITY,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetIndividualEntity = () => {
  return { type: RESET_INDIVIDUAL_ENTITY };
};

const getIndividualEntity = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_INDIVIDUAL_ENTITY });
  await partnerServices
    .post("addIndividualEntity", userData, { headers: { AuthToken: authTokenIs } })

    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(individualEntitysuccess(res.data));
          // history.push({ pathname: "/index/homepage" });
          break;
        default:
          dispatch(individualEntityfailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_INDIVIDUAL_ENTITY, payload: err });
    });
};
function individualEntitysuccess(data) {
  return {
    type: INDIVIDUAL_ENTITY_SUCCESS,
    payload: data,
  };
}
function individualEntityfailed(data) {
  return {
    type: INDIVIDUAL_ENTITY_FAILED,
    payload: data,
  };
}

export { resetIndividualEntity, getIndividualEntity };
